import { Loader2 } from 'lucide-react';
import { Address } from 'viem';
import { useBalance } from 'wagmi';
import EthereumFormatUnits from './EthereumFormatUnits';

interface Props {
  address?: Address;
}

export default function EthereumAccountBalanceOf({ address }: Props) {
  const { data, isLoading } = useBalance({ address });
  return (
    <>
      {isLoading && (
        <div className="mr-1 inline-block align-middle">
          <Loader2 className="text-blue-500 animate-spin w-4 h-4" />
        </div>
      )}
      <EthereumFormatUnits value={data?.value} />
    </>
  );
}
